module.exports = __webpack_public_path__ + "static/media/wateruser-cities.28543473.png";